if (!window.__cuftLpInit) {
  window.__cuftLpInit = 1;
(function(){
  // image placeholder fallback
  function fallback(img){
    var d=document.createElement('div');
    d.className='cft-ph-fallback';
    d.textContent=(img.getAttribute('data-label')||'Image').replace(/&middot;/g,'\u00b7');
    if(img.parentNode) img.parentNode.replaceChild(d,img);
  }
  document.querySelectorAll('img.cft-ph-img').forEach(function(img){
    if(img.complete && img.naturalWidth===0){ fallback(img); }
    else { img.addEventListener('error',function(){ fallback(img); }); }
  });

  // sticky nav shadow
  var nav=document.getElementById('cft-nav');
  function onScroll(){ if(nav){ nav.classList.toggle('cft-scrolled', window.scrollY>8); } }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

  // scroll reveal
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=document.querySelectorAll('.cft-reveal');
  if(reduce || !('IntersectionObserver' in window)){
    els.forEach(function(e){e.classList.add('cft-in');});
  } else {
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('cft-in'); io.unobserve(en.target); } });
    },{rootMargin:'0px 0px -8% 0px',threshold:0.08});
    els.forEach(function(e){io.observe(e);});
  }
})();
}
